import { ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import { AbstractControl, UntypedFormBuilder, UntypedFormGroup, NgModel, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { ActionSheetController, ModalController, Platform } from '@ionic/angular';
import { AlertProfilePictureComponent } from 'src/app/alert-profile-picture/alert-profile-picture.component';
import { AppState } from 'src/app/app.service';
import { I18n } from 'src/app/i18n.service';
import { NativeService } from 'src/app/services/native.service';
import { SessionService } from 'src/app/session/session.service';
import { SpinnerService } from 'src/app/spinner.service';
import { ToasterService } from 'src/app/toaster.service';
import { User } from 'src/app/user/user.model';
import { UserService } from 'src/app/user/user.service';
import { CustomValidators } from './custom-validators';
import { HomeUiService } from '../../new-design/home-ui.service';
import { AndroidPermissions } from '@awesome-cordova-plugins/android-permissions/ngx';
import { Keyboard } from "@awesome-cordova-plugins/keyboard/ngx";

export interface UpdateUser {
  [updateUser: string]: any
}
@Component({
  selector: 'app-edit-profile',
  templateUrl: './edit-profile.component.html',
  styleUrls: ['./edit-profile.component.scss'],
})
export class EditProfileComponent implements OnInit {
  public frmSignup: UntypedFormGroup;
  @ViewChild('lName') lName: NgModel
  @ViewChild('managerEmailField') managerEmailField: NgModel
  @ViewChild('confirmPassword') confirmPassword: NgModel
  user: User
  savedUser: User
  dataRefresher: any
  isNewPhoto: boolean | true
  isPhotoUploaded: boolean;
  label: any;
  userUpdate: UpdateUser
  email: any
  password: any
  passwordType: string = 'password';
  passwordIcon: string = 'eye-off';
  isMobile: boolean;
  confirmPasswordLabel: string
  passwordLabel: string
  isMobileWebIos = false;
  isMobileWeb=false;
  firstName: string
  lastName: string
  userEmail: string
  pathRegistration
  managerEmail;
  managerEmails: string[] = [];
  editingManagerEmailIndex: number = null;
  path;
  isManagerEmailAddedInAdmin=false
  emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  dailyStepsArray
  constructor(private fb: UntypedFormBuilder,
    private appState: AppState,
    private dialog: MatDialog,
    private cdRef: ChangeDetectorRef,
    private modalController: ModalController,
    private userService: UserService,
    private sessionService: SessionService,
    private toastrService: ToasterService,
    public platform: Platform,
    private spinnerService: SpinnerService,
    private native: NativeService,
    public homeUiService: HomeUiService,
    public keyboard: Keyboard,
    private permissions: AndroidPermissions,
    private i18n: I18n,) {
      this.confirmPasswordLabel = this.i18n.t('Confirm password')
      this.passwordLabel = this.i18n.t('Password')
      this.frmSignup = this.createSignupForm();
      this.user = this.appState.get('currentUser')
      this.savedUser = new User(this.user)
      this.isMobile = appState.get("isMobile");
      this.pathRegistration = this.appState.get("pathRegistration");
      this.firstName = this.user.firstName
      this.lastName = this.user.lastName
      this.userEmail = this.user.email
      this.path = this.appState.get('currentPath');
  }

  ngOnInit() {
    this.dailyStepsArray= this.appState.get("DailyStepsData");
    this.managerEmails = [...(this.user?.managerEmails || [])];
    let managerEmailStep;
    let onboardingStepsData = this.dailyStepsArray
      .map(step => step.onboardingSteps)
      .filter(s => s != null && (Array.isArray(s) ? s?.length > 0 : true))
      .flatMap(s => Array.isArray(s) ? s : [s]);
    if (onboardingStepsData?.length>0) {
      managerEmailStep = onboardingStepsData?.filter((step) => step?.stepTypes == 'manager')
    }
    this.isManagerEmailAddedInAdmin = managerEmailStep?.length>0 || this.path?.enabledAttributes?.manager_email ? true: false
    this.resizeHeight();
    this.isMobileWeb = this.appState.get('MobileWeb')
    this.isMobileWebIos = this.appState.get('MobileWebIos');
    console.log("this.isMobileWeb value", this.isMobileWeb);
   }


   resizeHeight(){
    this.keyboard.onKeyboardDidShow().subscribe((info) => {
         const mobileLoginScreens = document.querySelector('.mobile-login-screen');
         const passwordScreen = document.querySelector('.profile-password-height');
         mobileLoginScreens.setAttribute('style', `height: calc(100vh - ${info.keyboardHeight}px); overflow-y: scroll; margin-block: 0 !important`);
         passwordScreen.setAttribute('style', `height: calc(100vh - ${info.keyboardHeight}px - 125px);`);
        });
        
        this.keyboard.onKeyboardDidHide().subscribe(() => {
          const mobileLoginScreens = document.querySelector('.mobile-login-screen');
          const passwordScreen = document.querySelector('.profile-password-height');
        mobileLoginScreens.setAttribute('style', `height: auto`);
        passwordScreen.setAttribute('style', `height: calc(100vh - 130px)`);
    })
  }

  // scrollToInput(input: HTMLElement) {
  //   const inputPosition = input.getBoundingClientRect().top + window.scrollY; 
  //   console.log(inputPosition, 'inputPosition');

  //   const desiredPosition = 430;  
  //   const container = document.querySelector('.mobile-login-screen') as HTMLElement; 
  //   container.scrollTo({
  //       top: desiredPosition,
  //       behavior: 'smooth'
  //   });
  // }

pwdInputFocus(event){
  const input = event.target as HTMLElement;
  // this.scrollToInput(input);   
}

confirmPwdInputFocus(event){
  const input = event.target as HTMLElement;
  // this.scrollToInput(input);
}

  createSignupForm(): UntypedFormGroup {
    return this.fb.group(
      {
        email: [
          null,
          Validators.compose([Validators.email, Validators.required])
        ],
        password: [
          null,
          Validators.compose([
            Validators.required,
            // check whether the entered password has a number
            CustomValidators.patternValidator(/\d/, {
              hasNumber: true
            }),
            // check whether the entered password has upper case letter
            CustomValidators.patternValidator(/[A-Z]/, {
              hasCapitalCase: true
            }),
            // check whether the entered password has a lower case letter
            CustomValidators.patternValidator(/[a-z]/, {
              hasSmallCase: true
            }),
            // check whether the entered password has a special character
            CustomValidators.patternValidator(
              /[ !@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/,
              {
                hasSpecialCharacters: true
              }
            ),
            Validators.minLength(7)
          ])
        ],
        confirmPassword: [null, Validators.compose([Validators.required])]
      },
      {
        // check whether our password and confirm password match
        validator: CustomValidators.passwordMatchValidator
      }
    );
  }

  requestPermissions() {
    this.permissions.checkPermission(this.permissions.PERMISSION.CAMERA)
      .then(result => {
        if (!result.hasPermission) {
          this.permissions.requestPermissions([
            this.permissions.PERMISSION.READ_MEDIA_IMAGES,
            this.permissions.PERMISSION.READ_EXTERNAL_STORAGE,
            this.permissions.PERMISSION.CAMERA]).then(async (res) => {
              if (res) {
                const fileResult = await this.native.showActionSheetForFiles();
                this.spinnerService.on();
                if (fileResult) {
                  this.refresh();
                  this.uploadPhoto(fileResult);
                } else {
                  this.spinnerService.off();
                }
              }
            })

        }
        else {

        }
      })
      .catch(err => console.error('Error checking permission:', err));
  }

  async chooseOption() {
    this.stopInterval()
    if (this.platform.is('android')) {
      this.requestPermissions();
    }
    else {
      const fileResult = await this.native.showActionSheetForFiles();
      this.spinnerService.on();
      if (fileResult) {
        this.refresh();
        this.uploadPhoto(fileResult);
      } else {
        this.spinnerService.off();
      }
    }
  }
  fileChangeEvent(event: Event) {
    const target = event.target as HTMLInputElement;
    const files = target.files as FileList;
    this.spinnerService.on();
    console.log('file event', files[0]);
    this.uploadPhoto(files[0]);
  }
  
  uploadPhoto(file: any) {
    const myFormData = new FormData();
    //myFormData.append('file', file.blob, file.blob.name);
    if (this.isMobile && !this.platform.is('android')) {
      myFormData.append('file', file.blob, file.blob.name);
    } else {
      myFormData.append('file', file, file.name);
    }
    this.userService.postProfilePic(myFormData).subscribe((result) => {
      this.spinnerService.off();
      // this.toastrService.success(this.i18n.t('Your profile has been saved successfully.', 'bottom'))
      console.log('result', result);
      this.sessionService.url = result['data']['url']
      this.user.imageUrl = this.sessionService.url
      this.uploadImage()
    }, error=>{
      this.spinnerService.off();
      this.toastrService.success(this.i18n.t(error))
    })
  }

  stopInterval() {
    if (this.dataRefresher) {
      clearInterval(this.dataRefresher)
    }
  }

  refresh() {
    this.dataRefresher =
      setInterval(() => {
        this.user.imageUrl = this.sessionService.url
      }, 500);
  }

  // Adds the typed email, or replaces the one being edited, and saves the list unless persist is false
  // (updateProfile saves it along with the rest of the profile). Returns false if the input was invalid.
  addManagerEmailChip(persist = true): boolean {
    const normalizedEmail = this.managerEmail?.trim()?.toLowerCase();
    if (!normalizedEmail) {
      return true;
    }
    if (!this.emailPattern.test(normalizedEmail)) {
      this.toastrService.warning(this.i18n.t('Please enter a valid manager email address.'));
      return false;
    }
    const duplicateIndex = this.managerEmails.indexOf(normalizedEmail);
    if (duplicateIndex > -1 && duplicateIndex !== this.editingManagerEmailIndex) {
      this.toastrService.warning(this.i18n.t('This email has already been added.'));
      return false;
    }
    const previousEmails = [...this.managerEmails];
    if (this.editingManagerEmailIndex !== null) {
      this.managerEmails[this.editingManagerEmailIndex] = normalizedEmail;
    } else {
      this.managerEmails.push(normalizedEmail);
    }
    this.managerEmail = '';
    this.editingManagerEmailIndex = null;
    if (persist) {
      this.persistManagerEmails(previousEmails, 'Manager email confirmed');
    }
    return true;
  }

  editManagerEmailChip(index: number) {
    this.editingManagerEmailIndex = index;
    this.managerEmail = this.managerEmails[index];
  }

  cancelManagerEmailEdit() {
    this.editingManagerEmailIndex = null;
    this.managerEmail = '';
  }

  removeManagerEmailChip(index: number) {
    const previousEmails = [...this.managerEmails];
    this.managerEmails.splice(index, 1);
    if (this.editingManagerEmailIndex === index) {
      this.cancelManagerEmailEdit();
    } else if (this.editingManagerEmailIndex !== null && this.editingManagerEmailIndex > index) {
      this.editingManagerEmailIndex--;
    }
    this.persistManagerEmails(previousEmails, 'Manager email removed');
  }

  // Saves only the manager email list: sends the last saved profile so unsaved name/password
  // edits in the form aren't submitted along with it. Reverts the list if the save fails.
  private persistManagerEmails(previousEmails: string[], successMessage: string) {
    const payload = new User(this.savedUser);
    payload.managerEmails = [...this.managerEmails];
    payload.password = undefined;
    payload.passwordConfirmation = undefined;
    delete payload.profileUploadedDay;
    delete payload.userBgColor;
    delete payload.pathGeneratedByKyper;
    delete payload.clientEnabledForKyper;
    this.spinnerService.on();
    this.userService.save(payload).subscribe((response) => {
      const updatedUser = new User((response.data as UpdateUser).updateUser);
      this.savedUser = new User(updatedUser);
      this.managerEmails = [...(updatedUser.managerEmails || [])];
      this.user.managerEmails = [...this.managerEmails];
      this.appState.set('currentUser', updatedUser);
      this.appState.set('managerEmail', this.managerEmails[0] || null);
      this.spinnerService.off();
      this.toastrService.success(this.i18n.t(successMessage));
    }, error => {
      this.managerEmails = previousEmails;
      this.spinnerService.off();
      this.toastrService.error(this.i18n.t(error));
    });
  }

  private applyManagerEmailEdit() {
    this.user.managerEmails = [...this.managerEmails];
  }

  uploadImage() {
    let profileUploadDay;
    if (this.user.imageUrl) {
      this.spinnerService.on();
      profileUploadDay = this.user.profileUploadedDay;
      delete this.user.profileUploadedDay;
      delete this.user.userBgColor;
      delete this.user.pathGeneratedByKyper;
       delete this.user.clientEnabledForKyper;
      this.applyManagerEmailEdit();
      this.userService.save(this.user).subscribe((response) => {
        this.userUpdate = response.data
        const updatedUser = new User(this.userUpdate.updateUser);
        this.user = updatedUser;
        this.savedUser = new User(updatedUser);
         this.appState.set('updateActionPoints', true)
         //this.user.profileUploadedDay = profileUploadDay;
        this.label = "";
        this.appState.set("currentUser", updatedUser);
        localStorage.setItem('userid', updatedUser.id.toString());
        this.spinnerService.off();
        this.isPhotoUploaded = true;
        this.toastrService.success(this.i18n.t("Profile Picture Added!"));
        console.log("update response", response);
      });
    
    }
  }
  gotoNextField(nextElement, field=null) {
    if(field === 'password' && this.frmSignup.controls.password.status === "INVALID"){
      console.log('password not validated');
      this.toastrService.warning(this.i18n.t('Please enter a valid password'))
    }
    nextElement.setFocus();
  }
  updateProfile() {
    let profileUploadDay;
    if ((this.user.password?.length>0 &&this.user.password?.trim()?.length>0)&& !this.sessionService.validatePassword(this.user.password)) {
     if(this.frmSignup.controls.password.status === "INVALID") {
        this.toastrService.warning(this.i18n.t('Please enter a valid password'))
        return
      }
    }
    // Commit anything still typed in the manager email field so it isn't lost on save
    if (!this.addManagerEmailChip(false)) {
      return;
    }
    if ((this.user.password == '' || this.user.password == undefined) && (this.user.passwordConfirmation == '' || this.user.passwordConfirmation == undefined)) {
      this.user.password = undefined
      this.user.passwordConfirmation = undefined
    }
    if (this.user.password == this.user.passwordConfirmation) {
      this.spinnerService.on()
      profileUploadDay = this.user.profileUploadedDay
      delete this.user.profileUploadedDay;
      delete this.user.userBgColor;
      delete this.user.pathGeneratedByKyper;
       delete this.user.clientEnabledForKyper;
      this.applyManagerEmailEdit();
      this.userService.save(this.user).subscribe(response => {
        this.userUpdate = response.data
        const updatedUser = new User(this.userUpdate.updateUser);
        this.user = updatedUser
        this.savedUser = new User(updatedUser)
         this.appState.set('updateActionPoints', true)
       // this.user.profileUploadedDay = profileUploadDay;
        this.label = ''
        this.appState.set('currentUser', updatedUser)
        this.managerEmails = [...(updatedUser.managerEmails || [])];
        if (this.managerEmails.length > 0) {
          this.appState.set("managerEmail", this.managerEmails[0])
        }
        this.spinnerService.off()
        this.isPhotoUploaded = true
        this.toastrService.success(this.i18n.t('Profile updated!'))
        this.modalController.dismiss();
        // window.location.reload();
      }, error=>{
        this.spinnerService.off();
        this.toastrService.error(this.i18n.t(error))
      })

    } else {
      this.toastrService.warning(this.i18n.t('Password is not matched'))
    }
  }

  close() {
    this.modalController.dismiss();
    const userData = {
      firstName: this.firstName,
      lastName: this.lastName,
      userEmail: this.userEmail
    }
    this.appState.set('userData',userData)
  }

  hideShowPassword() {
    this.passwordType = this.passwordType === 'text' ? 'password' : 'text';
    this.passwordIcon = this.passwordIcon === 'eye-off' ? 'eye' : 'eye-off';
  }

  refreshComponent() {
    
  }
}
